import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yi-main',
  template: require('./main.component.html'),
  styles: [require('./main.component.scss')]
})
export class MainComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
